import React, { useState } from "react";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import AddIcon from "@mui/icons-material/Add";
import CustomModal from "../../../shared/components/Modal/CustomModal";
import { toast } from "react-toastify";
import ListCategoryModal from "../../../shared/components/Modal/ListCategoryModal/ListCategoryModal";
import { useSelector } from "react-redux";
import { Select, MenuItem, Modal, Box, Typography } from "@mui/material";
import { useForm } from "react-hook-form";
import EditIcon from "@mui/icons-material/Edit";
import useAuth from "../../../hooks/useAuth";

const StyledTableCell = styled(TableCell)(() => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "rgba(243, 244, 251, 1)",
    color: "rgba(86, 99, 202, 1)",
    fontSize: "16px",
    fontWeight: "600",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    color: "rgba(19, 19, 19, 1)",
    border: 0,
  },
}));

const StyledTableRow = styled(TableRow)(() => ({
  "&:nth-of-type(odd)": {
    backgroundColor: "rgba(220, 222, 243, 0.1)",
  },
  "&:nth-of-type(even)": {
    backgroundColor: "rgba(220, 222, 243, 0.35)",
  },
}));

const apiEndpoints = {
  "Тип сделки": "transaction_type",
  "Тип недвижимости": "property_type",
  Состояние: "property_condition",
  Комнаты: "rooms",
  Этажи: "floor",
  Документ: "document_type",
  Коммуникации: "communication_type",
  "Тип предложения": "offer_type",
  Мебель: "furniture_types",
  "Вид платежа": "payment_type",
  "Статус объекта": "object_status",
};

const propertyTypes = [
  "Вторичная",
  "Дома и участки",
  "Коммерческая",
  "Элитка",
  "Парковка",
];

const rows = [
  { id: 1, name: "Тип сделки" },
  { id: 2, name: "Тип недвижимости" },
  { id: 3, name: "Состояние" },
  { id: 4, name: "Комнаты" },
  { id: 5, name: "Этажи" },
  { id: 6, name: "Документ" },
  { id: 7, name: "Коммуникации" },
  { id: 8, name: "Тип предложения" },
  { id: 9, name: "Мебель" },
  { id: 10, name: "Вид платежа" },
  { id: 11, name: "Статус объекта" },
];

export default function TableCategory() {
  const [open, setOpen] = useState(false);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [deleteData, setDeleteData] = useState([]);
  const [listDeleteLoading, setListDeleteLoading] = useState(false);
  const [selectedPropertyType, setSelectedPropertyType] = useState("");
  const { auth } = useAuth();
  const token = auth?.access_token;
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const openAddModal = (row) => {
    setSelectedRow(row);
    setOpen(true);
  };

  const closeAddModal = () => {
    setOpen(false);
    setSelectedRow(null);
  };

  const openEditModal = async (row) => {
    setSelectedRow(row);
    setDeleteOpen(true);
    await fetchDeleteData(row);
  };

  const closeDeleteModal = () => {
    setDeleteOpen(false);
    setSelectedRow(null);
    setDeleteData([]);
  };

  const fetchDeleteData = async (row) => {
    const endpointKey = apiEndpoints[row.name];
    if (!endpointKey) return;
    setListDeleteLoading(true);

    const endpoint = `${process.env.REACT_APP_API_URL}/api/v1/${endpointKey}/`;

    try {
      const response = await fetch(endpoint, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      if (!response.ok) {
        throw new Error(`Ошибка загрузки: ${response.statusText}`);
      }
      const data = await response.json();
      setListDeleteLoading(false);
      setDeleteData(data);
    } catch (error) {
      setListDeleteLoading(false);
      console.error("Ошибка получения данных:", error);
    }
  };

  const onSubmit = async (data) => {
    if (!selectedRow) return;

    const endpointKey = apiEndpoints[selectedRow.name];
    if (!endpointKey) return;

    const endpoint = `${process.env.REACT_APP_API_URL}/api/v1/${endpointKey}/`;
    const payload = { name: data.name };

    try {
      const response = await fetch(endpoint, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        const responseDataError = await response.json();
        const errorMessage = responseDataError.error || "Произошла ошибка";
        toast.error(errorMessage);
      } else {
        toast.success(`Добавлено в ${selectedRow.name}: ${data.name}`);
      }
    } catch (error) {
      console.error("Ошибка запроса:", error);
    }
    closeAddModal();
  };

  const handleDelete = async (id) => {
    if (!selectedRow) return;

    const endpointKey = apiEndpoints[selectedRow.name];
    if (!endpointKey) return;

    const endpoint = `${process.env.REACT_APP_API_URL}/api/v1/${endpointKey}/${id}`;

    try {
      const response = await fetch(endpoint, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error(`Ошибка при удалении: ${response.statusText}`);
      }
      toast.success("Удалено успешно!");
      setDeleteOpen(false);
      setDeleteData((prev) => prev.filter((item) => item.ID !== id));
    } catch (error) {
      console.error("Ошибка удаления:", error);
    }
  };
  const handleEdit = async (id, name) => {
    if (!selectedRow) return;

    const endpointKey = apiEndpoints[selectedRow.name];
    if (!endpointKey) return;

    const endpoint = `${process.env.REACT_APP_API_URL}/api/v1/${endpointKey}/${id}`;
    const payload = { name };

    try {
      const response = await fetch(endpoint, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        const responseDataError = await response.json();
        const errorMessage = responseDataError.error || "Произошла ошибка";
        toast.error(errorMessage);
      } else {
        toast.success(`Изменено в ${selectedRow.name}: ${name}`);
        setDeleteData((prev) =>
          prev.map((item) => (item.ID === id ? { ...item, name: name } : item)),
        );
      }
    } catch (error) {
      console.error("Ошибка запроса:", error);
    }
  };

  const handlePropertyTypeChange = (event) => {
    console.log("Выбранный тип недвижимости:", event.target.value);
    setSelectedPropertyType(event.target.value);
  };

  return (
    <>
      <Paper sx={{ boxShadow: "none" }}>
        <TableContainer>
          <Table sx={{ minWidth: 700 }} aria-label="customized table">
            <TableHead>
              <TableRow>
                <StyledTableCell>Название</StyledTableCell>
                <StyledTableCell align="right">Действия</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((item) => (
                <StyledTableRow key={item.id}>
                  <StyledTableCell>{item.name}</StyledTableCell>
                  <StyledTableCell align="right">
                    <button
                      style={{
                        backgroundColor: "rgba(194, 158, 255, 1)",
                        padding: 10,
                        borderRadius: 8,
                        cursor: "pointer",
                        marginRight: 10,
                      }}
                      onClick={() => openAddModal(item)}
                    >
                      <AddIcon sx={{ color: "#fff" }} />
                    </button>

                    <button
                      style={{
                        backgroundColor: "rgba(220, 222, 243, 1)",
                        padding: 10,
                        borderRadius: 8,
                        cursor: "pointer",
                      }}
                      onClick={() => openEditModal(item)}
                    >
                      <EditIcon sx={{ color: "#000" }} />
                    </button>
                  </StyledTableCell>
                </StyledTableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>

      {/* Модалка для типа недвижимости */}
      {selectedRow?.name === "Тип недвижимости" && (
        <Modal
          open={open}
          onClose={closeAddModal}
          aria-labelledby="modal-title"
          aria-describedby="modal-description"
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              backgroundColor: "white",
              padding: 4,
              borderRadius: 2,
              boxShadow: 24,
              width: 400,
            }}
          >
            <Typography variant="h6" id="modal-title" sx={{ marginBottom: 2 }}>
              Выберите тип недвижимости
            </Typography>

            <form onSubmit={handleSubmit(onSubmit)}>
              <Select
                defaultValue={selectedPropertyType}
                onChange={handlePropertyTypeChange}
                fullWidth
                {...register("name", {
                  required: "Выберите тип недвижимости",
                })}
              >
                <MenuItem value="" disabled>
                  Выберите тип недвижимости
                </MenuItem>
                {propertyTypes.map((type, index) => (
                  <MenuItem key={index} value={type}>
                    {type}
                  </MenuItem>
                ))}
              </Select>

              {errors.propertyType && (
                <Typography variant="body2" color="error" sx={{ mt: 1 }}>
                  {errors.propertyType.message}
                </Typography>
              )}

              <button
                style={{ marginTop: 20 }}
                type="submit"
                className="saveButton"
              >
                Добавить тип недвижимости
              </button>
            </form>
          </Box>
        </Modal>
      )}

      {/* Модалка для добавления */}
      {selectedRow?.name !== "Тип недвижимости" && (
        <CustomModal
          open={open}
          onClose={closeAddModal}
          title={selectedRow ? `Добавить в ${selectedRow.name}` : "Добавить"}
          mode="add"
          fields={[
            {
              name: "name",
              label: "Название",
              placeholder: "Введите название",
              validation: { required: "Поле обязательно" },
            },
          ]}
          onConfirm={onSubmit}
        />
      )}

      {/* Модалка для удаления и редакт */}
      <ListCategoryModal
        open={deleteOpen}
        onClose={closeDeleteModal}
        title={selectedRow ? `Удалить из ${selectedRow.name}` : "Удалить"}
        mode="delete"
        list={deleteData}
        onDelete={handleDelete}
        onEdit={handleEdit}
        loading={listDeleteLoading}
      />
    </>
  );
}
